import { render, staticRenderFns } from "./stufocus.vue?vue&type=template&id=07b3d284&scoped=true&"
import script from "./stufocus.vue?vue&type=script&lang=js&"
export * from "./stufocus.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "07b3d284",
  null
  
)

export default component.exports